module.exports = __webpack_public_path__ + "static/media/node.4f62e11d.png";